(function () {
  'use strict';

  // Validates every cart-line qty input against its data-moq-min and data-moq-inc.
  // Disables the checkout button + shows a banner if any line is invalid.
  // Re-runs on input change and when the cart re-renders (cart-items-component
  // replaces innerHTML on update).

  function findInputs(scope) {
    return Array.from((scope || document).querySelectorAll('input[data-moq-min]'));
  }

  function findCheckoutButtons() {
    return Array.from(document.querySelectorAll('.hdt-main-cart__button-checkout, button[name="checkout"]'));
  }

  function getBanner() {
    var banner = document.getElementById('hdt-moq-validation-banner');
    if (banner) return banner;
    banner = document.createElement('div');
    banner.id = 'hdt-moq-validation-banner';
    banner.setAttribute('role', 'alert');
    banner.style.cssText =
      'display:none;margin:12px 0;padding:12px 16px;border:1px solid #d33;background:#fff5f5;color:#a00;font-size:14px;border-radius:4px;';
    var form = document.querySelector('cart-items-component') || document.querySelector('form[action*="/cart"]');
    if (form && form.parentNode) {
      form.parentNode.insertBefore(banner, form);
    } else {
      document.body.appendChild(banner);
    }
    return banner;
  }

  function nextValid(qty, min, inc) {
    if (qty < min) return min;
    if (inc > 1 && qty % inc !== 0) return Math.ceil(qty / inc) * inc;
    return qty;
  }

  function validate() {
    var inputs = findInputs();
    var errors = [];
    inputs.forEach(function (inp) {
      var qty = parseInt(inp.value, 10) || 0;
      var min = parseInt(inp.dataset.moqMin, 10) || 1;
      var inc = parseInt(inp.dataset.moqInc, 10) || 1;
      var label = inp.dataset.productTitle || 'this item';

      var isInvalid = false;
      var msg = '';
      if (min > 1 && qty < min) {
        isInvalid = true;
        msg = label + ' has a minimum order of ' + min + ' (currently ' + qty + ').';
      } else if (inc > 1 && qty % inc !== 0) {
        isInvalid = true;
        var next = nextValid(qty, min, inc);
        msg =
          label +
          ' must be ordered in multiples of ' +
          inc +
          '. Try ' +
          next +
          ' instead of ' +
          qty +
          '.';
      }

      if (isInvalid) {
        errors.push(msg);
        inp.style.borderColor = '#d33';
        inp.setCustomValidity(msg);
      } else {
        inp.style.borderColor = '';
        inp.setCustomValidity('');
      }
    });

    var banner = getBanner();
    var buttons = findCheckoutButtons();
    if (errors.length) {
      banner.innerHTML =
        '<strong>Order quantity needs adjusting:</strong><ul style="margin:6px 0 0 18px;padding:0;">' +
        errors.map(function (e) { return '<li>' + e + '</li>'; }).join('') +
        '</ul>';
      banner.style.display = 'block';
      buttons.forEach(function (b) {
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
        b.style.opacity = '0.5';
        b.style.cursor = 'not-allowed';
      });
    } else {
      banner.style.display = 'none';
      buttons.forEach(function (b) {
        b.disabled = false;
        b.removeAttribute('aria-disabled');
        b.style.opacity = '';
        b.style.cursor = '';
      });
    }
  }

  function attachListeners(scope) {
    findInputs(scope).forEach(function (inp) {
      if (inp._moqBound) return;
      inp._moqBound = true;
      inp.addEventListener('change', validate);
      inp.addEventListener('input', validate);
    });
  }

  function init() {
    attachListeners();
    validate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the cart-items-component replaces its body after a qty update
  var observer = new MutationObserver(function () {
    attachListeners();
    validate();
  });
  var target = document.querySelector('cart-items-component') || document.body;
  observer.observe(target, { childList: true, subtree: true });

  // Final guard: if a qty change event ever bubbles up that we missed, re-validate
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[data-moq-min]')) validate();
  });
})();
